<template>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>ATESTADO PSICOLÓGICO - Conceito e finalidade&nbsp;</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Estrutura</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 5º A formulação desse documento deve restringir-se à informação solicitada, contendo&nbsp;expressamente&nbsp;o&nbsp;fato&nbsp;constatado.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">As&nbsp;informações&nbsp;deverão&nbsp;estar&nbsp;registradas&nbsp;em&nbsp;texto&nbsp;corrido,&nbsp;separadas&nbsp;apenas&nbsp;pela&nbsp;pontuação,&nbsp;sem&nbsp;parágrafos,&nbsp;evitando,&nbsp;com&nbsp;isso,&nbsp;riscos&nbsp;de&nbsp;adulteração.</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">No&nbsp;caso&nbsp;em&nbsp;que&nbsp;seja&nbsp;necessária&nbsp;a&nbsp;utilização&nbsp;de&nbsp;parágrafos,&nbsp;a(o)&nbsp;psicóloga(o)&nbsp;deverá&nbsp;preencher&nbsp;esses espaços&nbsp;com&nbsp;traços.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 6º O atestado psicológico deve apresentar as informações da estrutura detalhada abaixo:&nbsp;</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"
          ><span lang="PT" dir="ltr">Título:<strong> "Atestado&nbsp;Psicológico"</strong>;</span></span
        >
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome&nbsp;da&nbsp;pessoa&nbsp;ou&nbsp;instituição&nbsp;atendida:&nbsp;identificação&nbsp;do&nbsp;nome&nbsp;completo&nbsp;ou&nbsp;nome&nbsp;social&nbsp;completo&nbsp;e, quando&nbsp;necessário, outras&nbsp;informações sócio-demográficas;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome do solicitante: identificação de quem solicitou o documento, especificando se a&nbsp;solicitação foi realizada pelo Poder Judiciário, por empresas, instituições públicas ou privadas,&nbsp;pelo&nbsp;próprio&nbsp;usuário&nbsp;do&nbsp;processo&nbsp;de&nbsp;trabalho&nbsp;prestado&nbsp;ou&nbsp;por&nbsp;outros&nbsp;interessados;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Finalidade:&nbsp;descrição&nbsp;da&nbsp;razão&nbsp;ou&nbsp;motivo&nbsp;do&nbsp;pedido;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Descrição das condições psicológicas do beneficiário do serviço psicológico advindas do&nbsp;raciocínio&nbsp;psicológico&nbsp;ou&nbsp;processo&nbsp;de&nbsp;avaliação&nbsp;psicológica&nbsp;realizado,&nbsp;respondendo&nbsp;a&nbsp;finalidade&nbsp;deste. Quando justificadamente necessário, fica facultado à(ao) psicóloga(o) o uso da&nbsp;Classificação Internacional de Doenças (CID) ou outras Classificações de diagnóstico, científica&nbsp;e&nbsp;socialmente&nbsp;reconhecidas, como&nbsp;fonte para&nbsp;enquadramento&nbsp;de&nbsp;diagnóstico;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">O documento deve ser encerrado com indicação do local, data de emissão, carimbo, em&nbsp;que conste nome completo ou nome social completo da(do) psicóloga(o), acrescido de sua&nbsp;inscrição&nbsp;profissional,&nbsp;com&nbsp;todas&nbsp;as&nbsp;laudas&nbsp;numeradas,&nbsp;rubricadas&nbsp;da&nbsp;primeira&nbsp;até&nbsp;a&nbsp;penúltima&nbsp;lauda,&nbsp;e a&nbsp;assinatura&nbsp;da(o)&nbsp;psicóloga(o)&nbsp;na&nbsp;última&nbsp;página.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 7º É facultado à(ao) psicóloga(o) destacar, ao final do atestado psicológico, que este não&nbsp;poderá ser utilizado para fins diferentes do apontado no item de identificação, que possui&nbsp;caráter&nbsp;sigiloso&nbsp;e que&nbsp;se trata&nbsp;de&nbsp;documento&nbsp;extrajudicial.</strong></span></span
    >
  </p>
  <p style="margin-left: 0cm; text-align: justify">&nbsp;</p>
</template>
